import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import ChefForPartyService from "../../services/ChefForPartyService";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (ingredientId: number, quantity: string) => Promise<void>;
}

let chefForPartyService = new ChefForPartyService();


const AddIngredientDialog = ({ open, onClose, onSubmit }: Props) => {
  const [ingredients, setIngredients] = useState<any[]>([]);
  const [ingredient, setIngredient] = useState<any>(null);
  const [quantity, setQuantity] = useState<string>("");
  const [loading, setLoading] = useState(false);

// TODO: This API is being called multiple times. Refactor to fetch the data once and reuse it.
  useEffect(() => {
    if (!open) return;

    chefForPartyService.getAllIngredientsForParty(1000, 0, {}, {}).then((response: any) => {
            if (response && response.data) {
                setIngredients(response.data);
            }
        }).catch((error: any) => {
            console.error("Error fetching ingredients:", error);
        });
  }, [open]);

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit(ingredient?.id, quantity);
    setLoading(false);
    setIngredient(null)
    setIngredients([])
    setQuantity("")
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Ingredient</DialogTitle>

      <DialogContent>
        <Autocomplete
          options={ingredients}
          getOptionLabel={(option: any) => option.name}
          value={ingredient}
          onChange={(_, v) => setIngredient(v)}
          renderInput={(params) => (
            <TextField {...params} label="Ingredient" margin="normal" />
          )}
        />

        <TextField
          fullWidth
          label="Quantity"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          margin="normal"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? <CircularProgress size={20} /> : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddIngredientDialog;
